module.exports = __webpack_public_path__ + "img/patrick-pro.bd5584b9.jpg";